import script from "./ActivityLogsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityLogsView.vue?vue&type=script&setup=true&lang=js"

import "./ActivityLogsView.vue?vue&type=style&index=0&id=3e48643e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e48643e"]])

export default __exports__